import { render, staticRenderFns } from "./StockdetailsReport.vue?vue&type=template&id=43d3489a"
import script from "./StockdetailsReport.vue?vue&type=script&lang=js"
export * from "./StockdetailsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports